<!--suppress CheckImageSize, JSUnresolvedVariable, ES6CheckImport -->
<template>
  <section class="game-center bg-light py-5">
    <div class="container">
      <!--标题-->
      <h3 class="text-center text-danger font-weight-bold wow fadeInDown">
        游戏
        <img
          :src="titleImgUrl"
          alt="logo"
          style="width: 50px"
          class="rounded-circle mx-2"
        />
        中心
      </h3>
      <div class="text-center mb-4 text-secondary wow fadeInUp">
        —— {{ sectionSubTitle }} ——
      </div>
      <!--内容-->
      <div class="row" v-if="logSys === 1">
        <div
          class="col-12 col-sm-6 col-lg-3 my-3"
          v-for="(item, index) in gameList"
          :key="index"
        >
          <el-card
            :body-style="{ padding: '0px' }"
            class="el-card border-0"
            shadow="hover"
          >
            <a href="#"><img :src="item.gameImg" alt="图片" class="w-100"/></a>
            <div style="padding: 14px;">
              <a href="#">
                <span class="font-weight-bold">{{ item.gameName }}</span>
              </a>
              <p class="bottom mt-2">
                <a href="#">
                  <span
                    class="badge badge-danger badge-pill"
                    v-if="item.gameTag === 1"
                    >hot</span
                  >
                  <span
                    class="badge badge-success badge-pill"
                    v-if="item.gameTag === 2"
                    >推荐</span
                  >
                  <span
                    class="badge badge-info badge-pill"
                    v-if="item.gameTag === 3"
                    >新上</span
                  >
                  {{ item.gameProfile }}
                </a>
              </p>
              <div class="text-center download-btn">
                <a
                  class="btn btn-success text-white btn-sm btn-block"
                  @click="downloadAndroid(item.gameId, item.androidUrl)"
                  v-if="isPC || isAndroid"
                >
                  <i class="fa fa-android" aria-hidden="true"></i>
                  安卓下载
                </a>
                <a
                  class="btn btn-danger text-white btn-sm btn-block mt-3"
                  @click="downloadIOS(item.gameId, item.iosUrl)"
                  v-if="isPC || isIOS"
                >
                  <i class="fa fa-apple" aria-hidden="true"></i>
                  IOS下载
                </a>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <!-- 小屏显示 -->
      <div class="phone-game-list" v-else>
        <div
          class="my-2 bg-white list-item row no-gutters"
          v-for="(item, index) in gameList"
          :key="index"
        >
          <div class="cover">
            <img :src="item.gameIcon" class="w-100 h-100" alt="封面" />
          </div>
          <div class="info col-6">
            <!--<div class="info col-9 ml-2">-->
            <div class="game-name font-weight-bold">
              {{ item.gameName }}
              <span
                class="badge badge-danger badge-pill"
                v-if="item.gameTag === 1"
                >hot</span
              >
              <span
                class="badge badge-success badge-pill"
                v-if="item.gameTag === 2"
                >推荐</span
              >
              <span
                class="badge badge-info badge-pill"
                v-if="item.gameTag === 3"
                >新上</span
              >
            </div>
            <div class="game-info">{{ item.gameProfile }}</div>
          </div>
          <div class="button-div flex-fill">
            <button
              class="btn btn-outline-success"
              @click="downloadAndroid(item.gameId, item.androidUrl)"
              v-if="isPC || isAndroid"
            >
              免费下载
            </button>
            <button
              class="btn btn-outline-danger"
              @click="downloadIOS(item.gameId, item.iosUrl)"
              v-if="isPC || isIOS"
            >
              免费下载
            </button>
          </div>
        </div>
      </div>
      <div class="text-center mt-4 wow fadeInDown">
        <router-link
          to="/toGameList"
          class="text-danger font-weight-bold find-more"
        >
          <img :src="moreImgUrl" alt="logo" width="40" class="rounded-circle" />
          查看更多
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { WOW } from "wowjs";

export default {
  name: "GameCenter",
  data() {
    return {
      isPC: false,
      isAndroid: false,
      isIOS: false,
      titleImgUrl: "",
      sectionSubTitle: "",
      moreImgUrl: "",
      logSys: 1,
      gameList: []
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.isSystem();
    this.getNavById();
    this.getHomeGameList();
  },
  methods: {
    downloadAndroid(gameId, androidUrl) {
      if (this.isWeiXin()) {
        alert("请使用浏览器打开网站下载！");
        return;
      }
      this.axios
        .put("/game/androidDownloads/" + gameId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            window.location.href = androidUrl;
          }
        })
        .catch();
    },
    downloadIOS(gameId, iosUrl) {
      if (this.isWeiXin()) {
        alert("请使用浏览器打开网站下载！");
        return;
      }
      this.axios
        .put("/game/iosDownloads/" + gameId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (this.logSys === 1) {
              window.open(iosUrl, "_blank"); // 新窗口打开外链接
            } else {
              window.location.href = iosUrl;
            }
          }
        })
        .catch();
    },

    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.isAndroid = true;
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.isIOS = true;
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.isIOS = true;
        this.logSys = 3;
      } else {
        this.isPC = true;
        this.logSys = 1;
      }
    },

    isWeiXin() {
      if (navigator.userAgent.match("MicroMessenger")) {
        return true;
      }
      return false;
    },

    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 4)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.titleImgUrl = resp.data.data.titleImg;
            this.sectionSubTitle = resp.data.data.subTitle;
            this.moreImgUrl = resp.data.data.moreImgUrl;
          }
        })
        .catch();
    },
    getHomeGameList() {
      this.axios
        .get("/game/getHomeGameList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.gameList = resp.data.data;
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.game-center {
  .container {
    a {
      text-decoration: none;
      color: #333;
    }

    .find-more {
      font-size: 18px;
    }

    @media only screen and (min-width: 576px) {
      .find-more {
        font-size: 14px;
      }
    }

    .row {
      div {
        .el-card {
          div {
            .bottom {
              height: 62px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }

            .download-btn {
              a {
                font-size: 24px;
              }

              @media only screen and (min-width: 576px) {
                a {
                  font-size: 14px;
                }
              }
            }
          }
        }

        .el-card:hover {
          box-shadow: 0 0 0.5rem rgba(220, 10, 25, 0.7);
          border-radius: 0;
        }
      }
    }

    .phone-game-list {
      .list-item {
        border-radius: 5px;
        padding: 10px 5px;
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        .cover {
          /*width: 25%;*/
          width: 72px;
          height: 72px;
          img {
            border-radius: 10px;
          }
        }
        .info {
          /*width: 60%;*/
          height: 72px;
          padding: 0 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          .badge {
            line-height: 1.5;
          }
          .game-info {
            font-size: 12px;
          }
        }

        .button-div {
          width: 51px;
          height: 72px;
          display: flex;
          justify-content: center;
          align-items: center;
          button {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
